'use strict';

angular.module('docketbook')
.directive('googleplace', function() {
  return {
    require: 'ngModel',
    scope: {
      ngModel: '=',
      addressModel: '='
    },
    link: function(scope, element, attrs, model) {
      var options = {
        types: []
      };
      scope.gPlace = new google.maps.places.Autocomplete(element[0], options);
      google.maps.event.addListener(scope.gPlace, 'place_changed', function() {
        scope.$apply(function() {
          model.$setViewValue(element.val());
          var fullPlace = scope.gPlace.getPlace();
          var newAddress = {};
          var locationComponents = {'subpremise' : 'num', 'street_number' : 'streetNum',
    				'route' : 'streetName', 'locality' : 'suburb', 'administrative_area_level_1' : 'state',
    				'postal_code' : 'postCode', 'country' : 'country', 'administrative_area_level_2' : 'city'};
          if ( fullPlace && fullPlace.address_components ) {
      			fullPlace.address_components.forEach(function(item) {
      				newAddress[locationComponents[item.types[0]]] = item.long_name;
              if ( item.types[0] == 'administrative_area_level_2' ) {
                newAddress[locationComponents[item.types[0]]] = item.short_name;
              }
      			});
          }
          scope.addressModel = newAddress;
        });
      });
    }
  };
});



// WEBPACK FOOTER //
// ./src/lib/directive/googleplace.js